import { type AnalyticsState, initialAnalyticsState } from "./analytics/AnalyticsState";
import { type ConfigState, initialConfigState } from "./config/ConfigState";
import { type EntitiesState, initialEntitiesState } from "./entities/EntitiesState";
import { type GlobalState, initialGlobalState } from "./global/GlobalState";
import { type LayoutState, initialLayoutState } from "./layout/LayoutState";
import { type PagesState, initialPagesState } from "./pages/PagesState";
import { type LocationState, initialLocationState } from "./route/RouteReducer";
import { type UsageTrackState, initialUsageTrackState } from "./usage-track/UsageTrackState";
import { type ViewState, initialViewState } from "./view/ViewState";
import { type VisualizerState, initialVisualizerState } from "./visualizer/VisualizerState";

export interface RootState {
	analytics: AnalyticsState;
	config: ConfigState;
	global: GlobalState;
	layout: LayoutState;
	view: ViewState;
	usageTrack: UsageTrackState;
	entities: EntitiesState;
	pages: PagesState;
	location: LocationState;
	visualizer: VisualizerState;
}

export const initialRootState: RootState = {
	analytics: initialAnalyticsState,
	config: initialConfigState,
	global: initialGlobalState,
	layout: initialLayoutState,
	view: initialViewState,
	usageTrack: initialUsageTrackState,
	entities: initialEntitiesState,
	pages: initialPagesState,
	location: initialLocationState,
	visualizer: initialVisualizerState,
};
